import { PropsWithChildren, useContext, useMemo } from 'react'
import { pick } from 'dot-object'
import { logWarning } from 'utils/log'
import { useText } from 'stores/utils/hooks/useText'
import FieldMetadataContext from './FieldMetadataContext'

interface Props {
  path: string
  labelPath?: string
}

const FieldMetadataProvider = ({
  children,
  path,
  labelPath = path
}: PropsWithChildren<Props>) => {
  const metadataContext = useContext(FieldMetadataContext)
  const { text } = useText()

  const metadata: Record<string, unknown> = useMemo(() => {
    let value = pick(path, text)

    if (!value && labelPath.length > 0) {
      value = pick(labelPath, text)
    }

    if (!value) {
      logWarning(`No metadata for ${path}`)

      return {}
    }

    return value
  }, [path, labelPath, text])

  const context = useMemo(
    () => ({ ...metadataContext, [path]: metadata }),
    [path, metadata, metadataContext]
  )

  return (
    <FieldMetadataContext.Provider value={context}>
      {children}
    </FieldMetadataContext.Provider>
  )
}

export default FieldMetadataProvider
